'use_strict';

module.exports = {
    setUserInfo: function () {
        $('body').on('login:success', function (e, data) {
            localStorage.setItem('contactId', data.contactID);
            _etmc.push(['setOrgId', window.mcOrgID]);
            _etmc.push(['setUserInfo', { email: data.contactID }]);
            _etmc.push(['trackPageView']);
        });
    },
    trackCartActivityPdp: function () {
        $('body').on('product:afterAddToCart', function (e, data) {
            var items = data && data.cart && data.cart.items ? data.cart.items : [];
            if (items.length) {
                // build date for mc
                var mcData = [];
                for (var i = 0; i < items.length; i++) {
                    mcData.push({
                        item: items[i].id,
                        quantity: items[i].quantity,
                        price: items[i].gtmData.price,
                        unique_id: items[i].id,
                    });
                }
                _etmc.push(['setOrgId', window.mcOrgID]);
                if (localStorage.getItem('contactId') !== 'null') {
                    _etmc.push([
                        'setUserInfo',
                        { email: localStorage.getItem('contactId') },
                    ]);
                }
                _etmc.push(['trackCart', { cart: mcData }]);
            } else {
                _etmc.push(['setOrgId', window.mcOrgID]);
                if (localStorage.getItem('contactId') !== 'null') {
                    _etmc.push([
                        'setUserInfo',
                        { email: localStorage.getItem('contactId') },
                    ]);
                }
                _etmc.push(['trackCart', { clear_cart: true }]);
            }
        });
    },
    trackCartFromCartPage: function () {
        $('body').on('cart:update', function (e, data) {
            // remove line item from cart
            var items = [];
            if ('basket' in data && data.basket) {
                items =
					data && data.basket && data.basket.items ? data.basket.items : [];
            } else if ('items' in data && data.items) {
                items = data && data.items ? data.items : [];
            }

            if (items.length) {
                var mcData = [];
                for (var i = 0; i < items.length; i++) {
                    mcData.push({
                        item: items[i].id,
                        quantity: items[i].quantity,
                        price: items[i].gtmData.price,
                        unique_id: items[i].id,
                    });
                }
                _etmc.push(['setOrgId', window.mcOrgID]);
                if (localStorage.getItem('contactId') !== 'null') {
                    _etmc.push([
                        'setUserInfo',
                        { email: localStorage.getItem('contactId') },
                    ]);
                }
                _etmc.push(['trackCart', { cart: mcData }]);
            } else {
                _etmc.push(['setOrgId', window.mcOrgID]);
                if (localStorage.getItem('contactId') !== 'null') {
                    _etmc.push([
                        'setUserInfo',
                        { email: localStorage.getItem('contactId') },
                    ]);
                }
                _etmc.push(['trackCart', { clear_cart: true }]);
            }
        });
    },
    unbindCustomerSession: function () {
        $('.js-logout-button').on('click', function () {
            localStorage.setItem('contactId', 'null');
        });
    },
    mcCollectCheckout: function () {
        $('body').on('login:success:checkout', function (e, data) {
            localStorage.setItem('contactId', data.contactID);
            _etmc.push(['setOrgId', window.mcOrgID]);
            _etmc.push(['setUserInfo', { email: data.contactID }]);
            _etmc.push(['trackPageView']);

            // remove line item from cart
            var items = [];
            if ('order' in data && data.order) {
                items =
					data && data.order && data.order.items && data.order.items.items
					    ? data.order.items.items
					    : [];
            } else if ('items' in data && data.items) {
                items = data && data.items ? data.items : [];
            }

            if (items.length) {
                var mcData = [];
                for (var i = 0; i < items.length; i++) {
                    mcData.push({
                        item: items[i].id,
                        quantity: items[i].quantity,
                        price: items[i].gtmData.price,
                        unique_id: items[i].id,
                    });
                }
                _etmc.push(['setOrgId', window.mcOrgID]);
                if (localStorage.getItem('contactId') !== 'null') {
                    _etmc.push([
                        'setUserInfo',
                        { email: localStorage.getItem('contactId') },
                    ]);
                }
                _etmc.push(['trackCart', { cart: mcData }]);
            } else {
                _etmc.push(['setOrgId', window.mcOrgID]);
                if (localStorage.getItem('contactId') !== 'null') {
                    _etmc.push([
                        'setUserInfo',
                        { email: localStorage.getItem('contactId') },
                    ]);
                }
                _etmc.push(['trackCart', { clear_cart: true }]);
            }
        });
    },
    handleRealTimeEvents: function () {
        if ($('.js-handle-marketing-cloud-events').length) {
            var productID = null;
            var urlPath = window.location.pathname;
            var pageName = 'HomePage';
            var querystring;
            var splitdata;
            var pageType = 'All';
            var action = $('.page').data('action');
            if (urlPath.indexOf('?q=') > -1) {
                pageName = 'Search';
            } else if ($('.storepage').length) {
                pageName = $('.storepage').attr('id');
                pageType = 'All';
            } else if (action === 'Search-Show') {
                querystring = $('.page').data('querystring');
                if (
                    querystring !== null &&
					querystring !== undefined &&
					querystring !== '' &&
					querystring !== 'null'
                ) {
                    splitdata = querystring.split('=');
                    pageName = splitdata[1];
                }
                pageType = 'All';
            } else if (action === 'Product-Show') {
                pageName = 'PDP';
                pageType = 'PDP';
                querystring = $('.page').data('querystring');
                if (
                    querystring !== null &&
					querystring !== undefined &&
					querystring !== '' &&
					querystring !== 'null'
                ) {
                    splitdata = querystring.split('=');
                    productID = splitdata[1];
                }
            } else if (action === 'Cart-Show') {
                pageName = 'Cart';
            } else if (action === 'Checkout-Begin') {
                pageName = 'Checkout';
            } else if (action === 'Order-Confirm') {
                pageName = 'Order Confirmation';
            } else if (action === 'Account-Show') {
                pageName = 'Account';
            } else if (action === 'Page-Show') {
                pageName = 'Content';
            }

            $.ajax({
                url: $('.js-handle-marketing-cloud-events').data('target-url'),
                type: 'POST',
                data: {
                    urlPath: urlPath,
                    pageName: pageName,
                    pageType: pageType,
                    productID: productID,
                },
                success: function () {
                    // eslint-disable-next-line no-console
                    console.info('Marketing Cloud Event Sent');
                },
                error: function () {
                    // eslint-disable-next-line no-console
                    console.error('Marketing Cloud Event Sent');
                },
            });
        }
    },
};
